// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IExpressSetupPlanDto
 */
export interface IExpressSetupPlanDto {
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupPlanDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof IExpressSetupPlanDto
     */
    parent_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupPlanDto
     */
    account_type?: IExpressSetupPlanDtoAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupPlanDto
     */
    plan_code?: string;
}

/**
* @export
* @enum {string}
*/
export enum IExpressSetupPlanDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}


/**
 * Check if a given object implements the IExpressSetupPlanDto interface.
 */
export function instanceOfIExpressSetupPlanDto(value: object): value is IExpressSetupPlanDto {
    return true;
}

export function IExpressSetupPlanDtoFromJSON(json: any): IExpressSetupPlanDto {
    return IExpressSetupPlanDtoFromJSONTyped(json, false);
}

export function IExpressSetupPlanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExpressSetupPlanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
    };
}

export function IExpressSetupPlanDtoToJSON(json: any): IExpressSetupPlanDto {
    return IExpressSetupPlanDtoToJSONTyped(json, false);
}

export function IExpressSetupPlanDtoToJSONTyped(value?: IExpressSetupPlanDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'parent_id': value['parent_id'],
        'account_type': value['account_type'],
        'plan_code': value['plan_code'],
    };
}

